import { adminHttpClient } from '../commons/adminHttpClient'
import { ProductIds } from '../commons/config'
import { UserRoles } from '../account/userRoles'
import { NamedItem, NamedItemInt, NamedItemString } from '../../domain/common/namedItem'

export type AuthResponse = {
  token: string
  status: AuthenticationStatus
  user: UserResponse
}

export enum AuthenticationStatus {
  Ok = 0,
  PasswordResetRequired = 1,
}

type UserResponse = {
  userId: string
  companyUserId: string
  productId: number
  companyId: string
  roles: UserRoles[]
  impersonatedBy: string
  companies: CompanyResponse[]
  hasAccessToInternalTools: boolean
}

type CompanyResponse = NamedItemString & {
  products: NamedItemInt[]
}

const auth = (
  username: string,
  password: string,
  productId: ProductIds,
  rememberMe: boolean,
): Promise<AuthResponse> => {
  return adminHttpClient.post('/auth', { username, password, productId, rememberMe })
}

export default auth
